import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('accessToken');
    
    if (storedUser && token) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (idToken) => {
    try {
      const response = await authAPI.googleLogin(idToken);
      const { access_token, refresh_token, user: userData } = response.data;

      localStorage.setItem('accessToken', access_token);
      localStorage.setItem('refreshToken', refresh_token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);

      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: error.response?.data?.error || 'Login failed' };
    }
  };

  const logout = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        await authAPI.logout(refreshToken);
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      setUser(null);
    }
  };

  // Merge saved profile fields into the cached user so the UI reflects them
  // immediately (without needing a re-login).
  const updateUser = (fields) => {
    setUser((prev) => {
      const next = { ...(prev || {}), ...fields };
      localStorage.setItem('user', JSON.stringify(next));
      return next;
    });
  };

  const isAdmin = () => user?.role === 'admin' || user?.role === 2;
  const isArtist = () => user?.role === 'artist' || user?.role === 1 || isAdmin();

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, loading, isAdmin, isArtist }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};